import { useState, useRef } from "react";
import "./SelectAndInput.css";
import { IoIosArrowDown, IoIosArrowForward } from "react-icons/io";


export default ({dataSelect, textView, filter, setFilter}) => {

    const [filteredOptions, setFilteredOptions] = useState(dataSelect);
    const [selectedOption, setSelectedOption] = useState('');
    const [display, setDisplay] = useState(false);

    const selectRef = useRef(null);

    const handleFilterChange = (e) => {
        const value = e.target.value;
        setFilter(value);
        changeFilter(value);
    };

    const changeFilter = (value) => {
        const filtered = dataSelect.filter(option =>
            option.toLowerCase().includes(value.toLowerCase())
        );

        setFilteredOptions(filtered);

        if (filtered.length === 0) {
            setDisplay(false);
        } else {
            setDisplay(true);
        }
    }

    const handleSelectChange = (event) => {
        setSelectedOption(event.target.value);
        setFilter(event.target.value);
        setDisplay(false);
    };

    const handInputDClick = () => {
        setFilter("");
        changeFilter("");
    }

    const handleKeyPress = (e) => {
        if (e.key === 'ArrowDown' || e.key === 'ArrowUp' || e.key === 'Enter') {
            e.preventDefault();

            if (e.key === 'ArrowDown' && (selectRef.current.selectedIndex < selectRef.current.options.length - 1)) {
                selectRef.current.selectedIndex += 1;
            } else if (e.key === "ArrowUp" && (selectRef.current.selectedIndex > 0)) {
                selectRef.current.selectedIndex -= 1;     
            } else if (e.key === 'Enter') {
                setSelectedOption(selectRef.current.value);
                setFilter(selectRef.current.value);
                setDisplay(false);      
            }
        }
    };

    return (
        <div className="select-and-input" onMouseLeave={() => setDisplay(false)}>
            <div>
                <input
                type="text"
                value={filter}
                placeholder={textView} 
                onChange={handleFilterChange}
                onClick={() => setDisplay(true)}
                onKeyDown={handleKeyPress}
                onDoubleClick={handInputDClick}
                />
                <p> {
                display ? 
                <IoIosArrowDown onClick={() => setDisplay(false)} /> 
                : <IoIosArrowForward onClick={() => setDisplay(true)} />
                } </p>

            </div>

            <select
            value={selectedOption}
            onChange={handleSelectChange}
            onKeyDown={handleKeyPress}
            style={{'display' : display ? 'block' : 'none'}}
            size={filteredOptions.length + 1}
            ref={selectRef}

            >
                <option></option>
                {
                    filteredOptions.map((value, key) => 
                        <option key={key} value={value}> {value} </option>
                    )
                }
            </select>
        </div>
    )
}